var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55 16.135c.322 0 .571-.139.754-.41L15.837 5.48c.132-.213.19-.381.19-.55 0-.417-.285-.703-.71-.703-.293 0-.461.11-.644.396L8.52 14.407l-3.18-4.138c-.182-.25-.365-.352-.636-.352-.433 0-.733.293-.733.71 0 .176.073.367.22.55l3.596 4.548c.22.278.447.41.762.41Z"
  })));
};
export default SvgCheck;